import { api } from '~/redux/api/createApi';

export const useDocumentGroups = (
  resourceId?: string | number,
  resourceType: 'document' | 'ticket' = 'document',
) => {
  return api.endpoints.listNodes.useQuery(
    { resourceType, resourceId: String(resourceId), include: 'groups' },
    { skip: !resourceId },
  );
};
